var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M34 1c1.1 0 2 .9 2 2v1h7.1C45.8 4 48 6.2 48 9v33c0 2.8-2.2 5-4.9 5H4.9C2.2 47 0 44.8 0 42V9c0-2.8 2.2-5 4.9-5H12V3c0-1.1.9-2 2-2s2 .9 2 2v1h16V3c0-1.1.9-2 2-2zm10 19H4v22c0 .6.4 1 1 1h38c.5 0 1-.4 1-1zM12 8H5c-.5 0-1 .4-1 1v7h40V9c0-.6-.4-1-1-1h-7v3c0 1.1-.9 2-2 2s-2-.9-2-2V8H16v3c0 1.1-.9 2-2 2s-2-.9-2-2z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0OCA0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibTM0IDJjMS4xIDAgMiAuOSAyIDJ2MWg3LjFjMi43IDAgNC45IDIuMiA0LjkgNXYzM2MwIDIuOC0yLjIgNS00LjkgNWgtMzguMmMtMi43IDAtNC45LTIuMi00LjktNXYtMzNjMC0yLjggMi4yLTUgNC45LTVoNy4xdi0xYzAtMS4xLjktMiAyLTJzMiAuOSAyIDJ2MWgxNnYtMWMwLTEuMS45LTIgMi0yem0xMCAxOWgtNDB2MjJjMCAuNi40IDEgMSAxaDM4Yy41IDAgMS0uNCAxLTF6bS0zMi0xMmgtN2MtLjUgMC0xIC40LTEgMXY3aDQwdi03YzAtLjYtLjQtMS0xLTFoLTd2M2MwIDEuMS0uOSAyLTIgMnMtMi0uOS0yLTJ2LTNoLTE2djNjMCAxLjEtLjkgMi0yIDJzLTItLjktMi0yeiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTEpIi8+PC9zdmc+Cg==";
export { SvgCalendar as ReactComponent };